// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel__wuswW","list":"styles_list__hxVqF","activeToggle":"styles_active-toggle__n0pRe"};